import React from "react";
import './whyResearchMate.css'
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import PhoneForwardedOutlinedIcon from '@mui/icons-material/PhoneForwardedOutlined';
import StarHalfOutlinedIcon from '@mui/icons-material/StarHalfOutlined';
import DoubleArrowOutlinedIcon from '@mui/icons-material/DoubleArrowOutlined';
import { Link } from "react-router-dom";

function WhyResearchMate() {
  return (
    <div className="p-20">
      <h4  style={{ color: '#169a8f'}}>Why Research Mate...?</h4>
      <div className='row col-md-12 mt-5'>
        <div className='col-md-6'>
          <h5 className="description">
            <span className="mx-3"> <CoPresentOutlinedIcon style={{ color: '#169a8f', fontSize: '40px', fontWeight: 'bolder' }} /></span>
            Site Selection</h5>
          <p className="para-style">Our PIs are go through a tough vetting process in order to gain access to our network. We also have an internal rating system based on our experiences to keep our network up to date & high quality. Some of our sites even have Kerlo employeed CRCs to monitor on site duties.</p>
        </div>
        <div className='col-md-6'>
          <h5 className="description">
            <span className="mx-3"> <LocalOfferOutlinedIcon style={{ color: '#169a8f', fontSize: '40px', fontWeight: 'bolder' }} /></span>
            Negotiate 1 Single Budget</h5>
          <p className="para-style">Finalize 1 single budget and CTA language regardless if you partner with 1 KR site or 10! Our budgeting & contracts team will streamline this process by mirroring it for multiple sites in one trial.</p>
        </div>
        <div className='col-md-6 mt-5'>
          <h5 className="description">
            <span className="mx-3"> <PhoneForwardedOutlinedIcon style={{ color: '#169a8f', fontSize: '40px', fontWeight: 'bolder' }} /></span>
            1 Point of Contact</h5>
          <p className="para-style">While our whole team would be thrilled to collaborate with you, we streamline communication by assiging you one experienced study manager. He or She will be your point person and ensure all sites and study progress are going smoothly and timely.</p>
        </div>
        <div className='col-md-6 mt-5'>
          <h5 className="description">
            <span className="mx-3"> <StarHalfOutlinedIcon style={{ color: '#169a8f', fontSize: '40px', fontWeight: 'bolder' }} /></span>
            Phases I-IV & Variety in Theraputic Area</h5>
          <p className="para-style">Gain access to experts no matter what phase or indication your study is in. Our Phase II-IV sites are highy experienced and Phase I sites are growing now more than ever. Kerlo Research been pushing to expand our network to include more Phase I sites to ensure you’re covered at any point in research.</p>
        </div>
      </div>
      <h5 className="mt-5">
        <Link to={'/sponsorForm'} className="links">
          Post as a Sponsor
          <span className="mx-3 ">
            <DoubleArrowOutlinedIcon
              style={{
                color: '#169a8f',
                fontSize: '60px',
                fontWeight: 'bolder',
                animation: 'ease-in-out'
              }} />
          </span>
        </Link>
      </h5>
    </div>
  );
}

export default WhyResearchMate;